import Upload from './src';

export default Upload;



// WEBPACK FOOTER //
// ./src/components/QnUpload-1.0.0/upload/index.js